import React from 'react';
import { createStyles, makeStyles, WithStyles, withStyles } from '@mui/styles';
import {
  DialogTitle,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
  Dialog,
  LinearProgress,
  Toolbar,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { customTheme } from '../../../styles/theme';

const styles = (theme: any) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const useStyles = makeStyles({
  form: {
    width: '100%', // Fix IE 11 issue.
  },
});

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const CustomDialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;

  // TODO: check it
  return (
    // @ts-ignore
    <DialogTitle disableTypography className={classes.root} {...other}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <Close />
          </IconButton>
        ) : null}
      </Toolbar>
    </DialogTitle>
  );
});

const CustomDialogContent = withStyles({
  root: {
    padding: customTheme.spacing(2),
  },
})(DialogContent);

const CustomDialogActions = withStyles({
  root: {
    margin: 0,
    padding: customTheme.spacing(2),
  },
})(DialogActions);

interface CustomDialogComponentProps {
  isOpen: boolean;
  onClose: Function;
  title?: any;
  content?: any;
  buttons?: any;
  isLoading?: boolean;
  styleOptions?: {
    fullWidth?: boolean;
  };
}

export default function CustomDialogComponent(props: CustomDialogComponentProps) {
  const classes = useStyles();

  return (
    <Dialog
      scroll={'paper'}
      maxWidth={false}
      fullWidth={props?.styleOptions?.fullWidth}
      onClose={() => props.onClose()}
      aria-labelledby="customized-dialog-title"
      open={props.isOpen}
    >
      <form className={classes.form}>
        <CustomDialogTitle id="customized-dialog-title" onClose={() => props.onClose()}>
          {props?.title}
        </CustomDialogTitle>
        <CustomDialogContent dividers>{props?.content}</CustomDialogContent>
        <CustomDialogActions>{props?.buttons}</CustomDialogActions>
      </form>

      {props.isLoading ? <LinearProgress /> : <></>}
    </Dialog>
  );
}
